export default {
  getHdList: process.env.VUE_APP_API_PREFIX + '/hd/hd/list',
  apply: process.env.VUE_APP_API_PREFIX + '/hd/hd/apply',
  getCC: process.env.VUE_APP_API_PREFIX + '/hd/hd/app_get_user_cc',
  //edit: process.env.VUE_APP_API_PREFIX + '/crm/wechat/edit',
  edit: process.env.VUE_APP_API_PREFIX + '/api-crm/open/wechat/create',
  getPassport: process.env.VUE_APP_API_PREFIX + '/api-passport/user/info/base',
  getUserWechat: process.env.VUE_APP_API_PREFIX + '/hd/hd/stat_click/', //{activity_id}
   // 获取cc二维码 https://admin-api.kmf.com/#/group/8/api/detail_1622
  getSellerInfo: process.env.VUE_APP_API_PREFIX + '/hd/apply/seller-code'
};
